import { LoadingService } from '@aionzdev/design-system';
import { afterNextRender, ChangeDetectionStrategy, Component, DestroyRef, ElementRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-loading',
  imports: [],
  templateUrl: './loading.html',
  styleUrl: './loading.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'popover': 'manual'
  }
})
export class Loading {
  private _service = inject(LoadingService);
  private _ref = inject(ElementRef);
  private _destroyRef = inject(DestroyRef);

  constructor() {
    afterNextRender(() => {
      const el = this._ref.nativeElement as HTMLElement & {
        showPopover(): void;
        hidePopover(): void;
      };

      this._service.isLoading$
        .pipe(distinctUntilChanged(), takeUntilDestroyed(this._destroyRef))
        .subscribe(loading => (loading ? el.showPopover() : el.hidePopover()));
    });
  }

}
